<template>

    <div class="other-field ">
        <div class="display-flex">
            <div class="label-width">
                <div class="label-icon"><i class="fas fa-language"></i></div>
                <div class="label-text">Translation / Message</div>
            </div>
            <div class="label-field">
                <textarea class="textarea" type="text" :rows="lines" placeholder="Please request translation"
                          v-model="translation.body"
                          :readonly="!isAdmin"></textarea>
            </div>
        </div>
        <div class="other-button text-center" v-if="isAdmin">
            <button class="button is-theme-primary"
                    v-bind:class="{ 'is-loading': isLoading }"
                    v-if="!isTranslated"
                    @click="createNewTranslation">Post
            </button>
            <button class="button is-theme-primary"
                    v-bind:class="{ 'is-loading': isLoading }"
                    v-if="isTranslated"
                    @click="updateTranslation">Update
            </button>
        </div>
    </div>
</template>

<script>
    import apiTranslations from './../../../../api/apiTranslations.js'

    export default {
        props: ['car'],
        data() {
            return {
                isLoading: false,
                isTranslated: false,
                lines: null,
                translation: {
                    lot_id: this.car.lot_id,
                    body: null
                }
            }
        },
        methods: {
            createNewTranslation() {
                this.isLoading = true
                apiTranslations
                    .placeTranslationRequest(this.translation)
                    .then((response) => {
                        this.translation = response.data
                        this.isTranslated = true
                        this.isLoading = false
                    })
                    .catch(error => console.log(error))
            },
            updateTranslation() {
                this.isLoading = true
                apiTranslations
                    .updateTranslationRequest(this.translation)
                    .then((response) => {
                        this.translation = response.data
                        this.isTranslated = true
                        this.isLoading = false
                    })
                    .catch(error => console.log(error))
            }
        },
        created() {
            apiTranslations
                .getTranslationRequest(this.car.translation_id)
                .then((response) => {
                    if (response.data.body.length > 0) {
                        this.translation = response.data
                        this.isTranslated = true
                        this.lines = this.translation.body.split(/\r\n|\r|\n/).length
                    }
                })
                .catch(error => console.log(error))
        },
        computed: {
            isAdmin() {
                if (this.$store.getters.getUserRole === 'Admin') {
                    return true
                }
            },
        },
    }
</script>

<style scoped>
    table {
        font-size: small;
    }
</style>




// WEBPACK FOOTER //
// src/components/Cars/Car/Details/TranslationBox.vue